import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const commodityTypesSchema: CollectionCreateSchema = {
  name: CollectionName.CommodityTypes,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "valid_from",
      type: "int64",
      optional: true,
    },
    {
      name: "valid_until",
      type: "int64",
      optional: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
